var path = 'app/components/radniNalog/humanDentalArches.html';
var html = "<div class=\"row\"><div class=\"col-lg-9 col-sm-8\"><dental-editor plan=\"vm.plan\" on-click=\"vm.pozicijaClicked(id)\" , on-veza=\"vm.vezaBtnClicked()\"></dental-editor></div><div class=\"col-lg-1 col-sm-2\"><button type=\"button\" class=\"btn btn-xs btn-success\" ng-click=\"vm.onBtnNovaStavkaClicked()\"><i class=\"fa fa-plus-square\"></i> Nova stavka</button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/radniNalog/humanDentalArches.html
// module id = 633
// module chunks = 0